import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ToastProvider from './components/ToastProvider';
import ConfirmProvider from './components/ConfirmProvider';

// Dark-first chrome: apply before first paint so bg-surface-* tokens aren't :root white.
try {
  const stored = window.localStorage.getItem('theme');
  if (stored !== 'light') document.documentElement.classList.add('dark');
} catch {
  document.documentElement.classList.add('dark');
}

// Prod-safe debug markers.
// Set via URL: ?debugSettings=1 or ?debugModal=1 (also persisted to localStorage)
// Read via console: window.__TESTARA_BUILD_INFO__
try {
  const url = new URL(window.location.href);
  const debugSettings = url.searchParams.get('debugSettings');
  const debugModal = url.searchParams.get('debugModal');
  if (debugSettings === '1') localStorage.setItem('testara_debug_settings', '1');
  if (debugModal === '1') localStorage.setItem('testara_debug_modal', '1');

  window.__TESTARA_BUILD_INFO__ = {
    name: 'testara-web',
    builtAt: '__BUILD_TIME__',
    gitSha: '__GIT_SHA__',
    reactAppEnv: process.env.NODE_ENV,
    href: window.location.href,
  };
  // eslint-disable-next-line no-console
  if (localStorage.getItem('testara_debug_settings') === '1' || localStorage.getItem('testara_debug_modal') === '1') {
    console.log('[TestaraDebug] build info', window.__TESTARA_BUILD_INFO__);
  }
} catch {
  // ignore
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Dev-only: `REACT_APP_DASHBOARD_PREVIEW=true npm start` renders the Dashboard
// with fixture data (src/dev/DashboardPreview.jsx). Compiled out of prod builds.
if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DASHBOARD_PREVIEW === 'true') {
  import('./dev/DashboardPreview').then(({ default: DashboardPreview }) => {
    root.render(<DashboardPreview />);
  });
} else root.render(
  <ConfirmProvider>
    <ToastProvider>
      <App />
    </ToastProvider>
  </ConfirmProvider>
);
